

<form #regForm="ngForm">
  @for (field of fields; track field) {
    @switch (field.fieldName) {
      <!--START FIRST NAME-->
      @case ('FirstName') {
        <div>
          <mat-form-field color="accent" appearance="fill" class="w-100">
            <mat-label>{{'_LOYALTY_REG.first_name' | translate}}</mat-label>
            <input [(ngModel)]="source.firstName" name="firstName" #txtFirstName="ngModel" matInput [required]="required" [matKeyboard]="$storage.customerKeyboard" (enterClick)="focusNext(reglastname)" autocomplete="reg-user-first-name" maxlength="50">
            @if (source.firstName) {
              <mat-icon matSuffix (click)="source.firstName = null">close</mat-icon>
            }
            @if (txtFirstName.invalid && (txtFirstName.dirty || txtFirstName.touched)) {
              <mat-error>{{'invalid-requiered' | translate}}</mat-error>
            }
          </mat-form-field>
        </div>
      }
      <!--START LAST NAME-->
      @case ('LastName') {
        <div>
          <mat-form-field color="accent" appearance="fill" class="w-100">
            <mat-label>{{'_LOYALTY_REG.last_name' | translate}}</mat-label>
            <input [(ngModel)]="source.lastName" name="lastName" #txtLastName="ngModel" matInput [required]="required" [matKeyboard]="$storage.customerKeyboard" (enterClick)="focusNext(regfirstname)" autocomplete="reg-user-last-name" maxlength="50">
            @if (source.lastName) {
              <mat-icon matSuffix (click)="source.lastName = null">close</mat-icon>
            }
            @if (txtLastName.invalid && (txtLastName.dirty || txtLastName.touched)) {
              <mat-error>{{'invalid-requiered' | translate}}</mat-error>
            }
          </mat-form-field>
        </div>
      }
      <!--START Email-->
      @case ('Email') {
        <div>
          <mat-form-field color="accent" appearance="fill" class="w-100">
            <mat-label>{{'_LOYALTY_REG.email' | translate}}</mat-label>
            <input [(ngModel)]="source.email" type="text" email name="email" #txtEmail="ngModel" matInput [required]="required" [matKeyboard]="'email'" (enterClick)="focusNext(reglastname)" autocomplete="new-password" maxlength="50" class="ltr-field">
            @if (source.email) {
              <mat-icon matSuffix (click)="source.email = null">close</mat-icon>
            }
            @if (txtEmail.invalid && (txtEmail.dirty || txtEmail.touched)) {
              <mat-error>{{'invalid-requiered' | translate}}</mat-error>
            }
          </mat-form-field>
        </div>
      }
      <!--START Zehut-->
      @case ('Zehut') {
        <div>
          <mat-form-field color="accent" appearance="fill" class="w-100">
            <mat-label>{{'_LOYALTY_REG.zehut' | translate}}</mat-label>
            <input [(ngModel)]="source.zehut" type="tel" name="zehut" #txtZehut="ngModel" validIdCard matInput [required]="required" [matKeyboard]="'phone'" (enterClick)="focusNext(reglastname)" autocomplete="new-password">
            @if (source.zehut) {
              <mat-icon matSuffix (click)="source.zehut = null">close</mat-icon>
            }
            @if (txtZehut.invalid && (txtZehut.dirty || txtZehut.touched)) {
              <mat-error>{{'invalid-requiered' | translate}}</mat-error>
            }
          </mat-form-field>
        </div>
      }
      <!--START BirthDate-->
      @case ('BirthDate') {
        <div (mousedown)="birthDatePicker.open()">
          <mat-form-field appearance="fill" class="w-100" style="pointer-events:none">
            <mat-label>{{'_LOYALTY_REG.birthDate' | translate}}</mat-label>
            <input [(ngModel)]="source.birthDate" name="birthDate" matInput [required]="required" [matDatepicker]="birthDatePicker" [max]="loyaltyService.maxBirthdayDate" [min]="loyaltyService.minBirthdayDate" [formControl]="birthDate">
            <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #birthDatePicker touchUi [startView]="'multi-year'"></mat-datepicker>
          </mat-form-field>
        </div>
      }
      <!--START Anniversary-->
      @case ('Anniversary') {
        <div (mousedown)="anniversaryPicker.open()">
          <mat-form-field appearance="fill" class="w-100" style="pointer-events:none">
            <mat-label>{{'_LOYALTY_REG.anniversary' | translate}}</mat-label>
            <input [(ngModel)]="source.anniversary" name="anniversary" matInput [required]="required" [matDatepicker]="anniversaryPicker" [max]="loyaltyService.maxAnniversary" [min]="loyaltyService.minAnniversary" [formControl]="anniversary">
            <mat-datepicker-toggle matSuffix [for]="anniversaryPicker"></mat-datepicker-toggle>
            <mat-datepicker #anniversaryPicker touchUi [startView]="'multi-year'"></mat-datepicker>
          </mat-form-field>
        </div>
      }
    }
  }

</form>
